export default "__VITE_ASSET__BCGZZHyi__"